// ServicesSection.jsx
// (Optional but recommended in index.html for exact typography)
// <link rel="preconnect" href="https://fonts.googleapis.com" />
// <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
// <link href="https://fonts.googleapis.com/css2?family=Archivo:wght@700;800&family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet" />

import React from "react";
import { Box, Container, Grid, Typography, IconButton } from "@mui/material";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

const services = [
  {
    title: "Emergency Water Mitigation",
    desc: "Water damage waits for no one. Our rapid-response team uses industrial-grade drying and extraction equipment to halt damage instantly. From burst pipes to flooded basements, we restore safety to your home fast. ",
    icon: "https://html.themehour.net/kleanix/demo/assets/img/icon/service-3-1.svg",
  },
  {
    title: "HVAC Maintenance & Repair",
    desc: "Indiana weather is unpredictable; your comfort shouldn't be. We handle installation, repair, and seasonal maintenance for furnaces and air conditioners. Keep your energy bills low and your system lifespan high. ",
    icon: "https://html.themehour.net/kleanix/demo/assets/img/icon/service-3-2.svg",
  },
  {
    title: "Professional Cleaning ",
    desc: "Experience the joy of a truly pristine home. Our detailed cleaning services go beyond the surface, ensuring a healthy environment for your family. We scrub, sanitize, and shine so you can relax. ",
    icon: "https://html.themehour.net/kleanix/demo/assets/img/icon/service-3-3.svg",
  },
];

const ServicesSection = () => {
  return (
    <>
      <style>{`
        :root {
          --service-bg: #f5f7fb;
          {/* --service-inner-max: 1220px; */}
          --service-radius-section: 56px;
          --service-card-radius: 10px;
          --service-card-bg-img: url("https://html.themehour.net/kleanix/demo/assets/img/bg/service-3-card-bg.png");
          --service-title: #111827;
          --service-body: #6b7280;
          --service-kicker: #7ac142;
          --service-arrow: #111827;
          --service-arrow-hover: #ffffff;
          --service-card-shadow: 0 24px 70px rgba(15, 23, 42, 0.10);
          --service-font-heading: "Archivo", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          --service-font-body: "DM Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          --service-anim-ease: cubic-bezier(0.16, 1, 0.3, 1);
        }

        .service-section {
          padding: 96px 16px 90px;
          display: flex;
          justify-content: center;
          background-color: #ffffff;
        }

        .service-shell {
          width: 100%;
          max-width: 1400px;
          background-image: url("https://html.themehour.net/kleanix/demo/assets/img/bg/service-3-bg.png");
          background-size: cover;
          background-position: center;
          border-radius: 10px;
          padding: 64px 60px 70px;
          position: relative;
          overflow: hidden;
        }

        .service-inner {
          max-width: var(--service-inner-max);
          margin: 0 auto;
        }

        /* floating shapes */
        .service-shape {
          position: absolute;
          pointer-events: none;
          z-index: 0;
        }

        .service-shape--yellow {
          top: 60px;
          left: 72px;
          width: 52px;
          animation: service-jump 3600ms ease-in-out infinite alternate;
        }

        .service-shape--green {
          bottom: 10px;
          left: 72px;
          width: 64px;
          animation: service-jump-reverse 3600ms ease-in-out infinite alternate;
        }

        @keyframes service-jump {
          0% { transform: translate3d(0, 0, 0); }
          50% { transform: translate3d(0, -10px, 0); }
          100% { transform: translate3d(0, 0, 0); }
        }

        @keyframes service-jump-reverse {
          0% { transform: translate3d(0, 0, 0); }
          50% { transform: translate3d(0, 10px, 0); }
          100% { transform: translate3d(0, 0, 0); }
        }

        /* heading row */
        .service-kicker-wrap {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 12px;
        }

        .service-kicker-line {
          width: 44px;
          height: 2px;
          border-radius: 10px;
          background: var(--service-kicker);
        }

        .service-kicker {
          font-family: var(--service-font-body);
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--service-kicker);
        }

        .service-heading {
          font-family: var(--service-font-heading);
          font-weight: 800;
          font-size: 34px;
          line-height: 1.2;
          color: var(--service-title);
          margin: 0;
        }

        .service-right-copy {
          font-family: var(--service-font-body);
          font-size: 14px;
          line-height: 1.8;
          color: var(--service-body);
          max-width: 440px;
        }

        /* cards */
        .service-card-column {
          margin-top: 40px;
        }

        .service-card {
          position: relative;
          display: flex;
          align-items: center;
          padding: 22px 28px;
          border-radius: 30px;
          background-image: var(--service-card-bg-img);
          background-size: cover;
          background-position: center;
          box-shadow: var(--service-card-shadow);
          cursor: pointer;
          max-width: 550px;
          transition:
            transform 220ms var(--service-anim-ease),
            box-shadow 220ms var(--service-anim-ease),
            background-position 220ms var(--service-anim-ease);
        }

        .service-card + .service-card {
          margin-top: 22px;
        }

        .service-card:hover {
          transform: translate3d(0, -4px, 0);
          box-shadow: 0 28px 80px rgba(15, 23, 42, 0.15);
          background-position: 50% 8%;
        }

        .service-card-icon {
          width: 84px;
          height: 84px;
          border-radius: 24px;
          background: rgba(255, 255, 255, 0.96);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 22px;
          flex-shrink: 0;
        }

        .service-card-icon img {
          width: 48px;
          height: 48px;
        }

        {/* .service-card-content {
          flex: 1;
        } */}

        .service-card-title {
          font-family: var(--service-font-heading);
          font-size: 18px;
          font-weight: 700;
          color: var(--service-title);
          margin: 0 0 4px;
        }

        .service-card-text {
          font-family: var(--service-font-body);
          font-size: 14px;
          color: var(--service-body);
          margin: 0;
        }

        .service-card-arrow {
          margin-left: 18px;
          width: 36px;
          height: 36px;
          border-radius: 10px;
          border: 1px solid rgba(15, 23, 42, 0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--service-arrow);
          background: #ffffff;
          transition:
            background-color 220ms var(--service-anim-ease),
            color 220ms var(--service-anim-ease),
            transform 220ms var(--service-anim-ease),
            box-shadow 220ms var(--service-anim-ease);
          flex-shrink: 0;
        }

        .service-card:hover .service-card-arrow {
          background: var(--service-kicker);
          color: var(--service-arrow-hover);
          transform: translate3d(2px, 0, 0);
          box-shadow: 0 8px 20px rgba(122, 193, 66, 0.45);
        }

        .service-card-arrow svg {
          font-size: 16px;
        }

        /* right image & green base */
        .service-image-wrap {
          position: relative;
          margin-top: 40px;
        }

        .service-image-base {
          position: absolute;
          inset: 35% 0 0 24%;
          background: #c9ed9c;
          border-radius: 0 0 var(--service-radius-section) var(--service-radius-section);
          transform: skewY(-4deg);
          transform-origin: top left;
        }

        .service-img-box {
          position: relative;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 26px 80px rgba(15, 23, 42, 0.45);
          max-width: 620px;
          margin-left: auto;
        }

        .service-img {
          display: block;
          width: 100%;
          height: auto;
        }

        /* responsive tweaks */
        @media (max-width: 1199px) {
          .service-shell {
            padding: 52px 32px 64px;
          }
        }

        @media (max-width: 959px) {
          .service-shell {
            border-radius: 10px;
          }
          .service-image-base {
            inset: 40% 0 0 0;
          }
          .service-img-box {
            margin: 32px auto 0;
          }
          .service-right-copy {
            margin-top: 16px;
            max-width: none;
          }
        }

        @media (max-width: 599px) {
          .service-shell {
            padding: 40px 18px 48px;
          }
          .service-heading {
            font-size: 28px;
          }
          .service-card {
            padding: 18px 18px;
            flex-wrap: wrap;
            justify-content: center;
          }
          .service-card-icon {
            width: 72px;
            height: 72px;
            margin-right: 16px;
          }
          .service-image-base {
            display: none;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .service-shape,
          .service-card,
          .service-card-arrow {
            animation: none !important;
            transition: none !important;
          }
        }
      `}</style>

      <Box component="section" className="service-section">
        <Box className="service-shell">
          {/* floating shapes */}
          {/* <img
            src="https://html.themehour.net/kleanix/demo/assets/img/shape/servicce-2-shape-theme2.svg"
            alt=""
            className="service-shape service-shape--yellow"
          /> */}
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/shape/home-3-shape-1.svg"
            alt=""
            className="service-shape service-shape--green"
          />

          <Container className="service-inner">
            {/* Top heading row */}
            <Grid
              container
              spacing={4}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item xs={12} md={6}>
                <Box>
                  <Box className="service-kicker-wrap">
                    <Box className="service-kicker-line" />
                    <Typography className="service-kicker">
                      OUR SERVICES
                    </Typography>
                    <Box className="service-kicker-line" />
                  </Box>
                  <Typography component="h2" className="service-heading">
                    The Services We Provide
                    <br />
                    For Our Customer
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={5}>
                <Typography className="service-right-copy">
                  These services are designed to maintain cleanliness, hygiene,
                  and overall appearance of homes, offering convenience to
                  homeowners and ensuring a healthy living environment. Routine
                  cleaning tasks performed weekly or bi-weekly.
                </Typography>
              </Grid>
            </Grid>

            {/* Cards + Image */}
            <Grid
              container
              spacing={{ xs: 4, md: 6 }}
              alignItems="center"
              sx={{ mt: 2 }}
            >
              {/* Left: service cards */}
              <Grid item xs={12} xl={5} md={6}>
                <Box className="service-card-column">
                  {services.map((service) => (
                    <Box
                      key={service.title}
                      className="service-card"
                      role="button"
                      aria-label={service.title}
                    >
                      <Box className="service-card-icon">
                        <img src={service.icon} alt="" />
                      </Box>
                      <Box className="service-card-content">
                        <Typography className="service-card-title">
                          {service.title}
                        </Typography>
                        <Typography className="service-card-text">
                          {service.desc}
                        </Typography>
                      </Box>
                      {/* <Box className="service-card-arrow">
                        <ArrowForwardIosRoundedIcon />
                      </Box> */}
                    </Box>
                  ))}
                </Box>
              </Grid>

              {/* Right: image with green base */}
              <Grid item xs={12} xl={7} md={6}>
                <Box className="service-image-wrap">
                  <Box className="service-image-base" aria-hidden="true" />
                  <Box className="service-img-box">
                    <img
                      src="https://html.themehour.net/kleanix/demo/assets/img/service/service_3_1.jpg"
                      alt="Cleaning staff working in a modern office"
                      className="service-img"
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default ServicesSection;
